import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import useNavModel from '../model/navModel'
import useGlobalModel from '../model/globalModel'
import { forFind } from '../utils/utils'
import menuData from '../data/menuData.json'
import { Layout, Spin } from 'antd'
import AppMenu from './AppMenu'
import AppHeader from './AppHeader'
import AppNav from './AppNav'
import AppRoute from './AppRoute'
import logo from '@/assets/images/menuLogo.png'
import logo1 from '@/assets/images/menuLogo1.png'
import { HomeOutlined } from '@ant-design/icons'

const { Sider, Content } = Layout

const Index = () => {
    const history = useHistory()
    const {
        user,
        cm,
        loadingInfo: { loadingVisible, txt },
        setLoadingInfo,
    } = useGlobalModel()
    const { addNav } = useNavModel()
    const REACT_APP_ENV = process.env.REACT_APP_ENV as 'DEV' | 'TEST' | 'PROD' | 'STAGE'
    //监听在地址栏输入url。
    useEffect(() => {
        history.listen((location, action) => {
            //每次切换页面 关闭全局loading
            setLoadingInfo({ loadingVisible: false, txt: '' })

            if (action === 'POP' && location.pathname !== '/login' && user.token) {
                let findNav = forFind(menuData, location.pathname, 'path', true)
                addNav(findNav ? findNav.id : '404')
            }
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Layout style={{ height: '100vh' }}>
            <Layout>
                <Sider className="layout-sider menu-box" trigger={null} collapsible collapsed={cm.collapsed} width={208}>
                    {/* <div className="layout-sider-shop">{user.shopName}1</div> */}
                    <div className="layout-sider-top">
                        <img src={REACT_APP_ENV === 'PROD' ? logo1 : logo1} alt="" />
                        <span>{REACT_APP_ENV === 'PROD' ? '云豪综合管理后台' : '云豪综合管理后台'}</span>
                    </div>
                    <div className="layout-sider-secondTop">
                        <HomeOutlined style={{ marginRight: '10px', marginTop: '3px', fontWeight: 'bolder' }} />
                        <div style={{ width: '69%' }}>
                            <span style={{ color: '#fff', fontWeight: 'bolder' }}>{user.createUser.split('-')[0]}</span>
                            {user.createUser.split('-').length > 1 && (
                                <span style={{ fontSize: '12px', marginTop: '3px', float: 'right' }}>-- {user.createUser.split('-')[1]}</span>
                            )}
                        </div>
                    </div>
                    <AppMenu />
                </Sider>
                <Layout className="layout-section">
                    <AppHeader />
                    <AppNav />
                    <Spin tip={txt} spinning={loadingVisible}>
                        <Content>
                            <div className="layout-section-content">
                                <AppRoute />
                            </div>
                        </Content>
                    </Spin>
                </Layout>
            </Layout>
        </Layout>
    )
}

export default Index
